<template>
    <div>
        <div class="top-header-container bottom-shadow">
            <div class="top-header" data-spm="nav">
                <header class="header__l" >
                    <a v-if="isSohuRefer" class="back-home" href="/" @click.prevent="clickSohuBar()" data-spm-data="1">
                        <i class="back"></i>
                        <span class="divide-line"></span>
                    </a>
                    <a class="back-home" href="/" data-spm-data="2">
                        <img src="../less/images/header-search-logo.png"/>
                    </a>
                </header>
                <!-- 作者信息与订阅 -->
                <div class="center-header" v-if="showAuthorFollow">
                    <!-- 订阅按钮 -->
                    <a id="headerFollowAuthor" @click="handleFollow" data-spm-data="4" href="javascript:;">
                        <img v-if="followStatus" class="followed" src="//statics.itc.cn/WAP_base/icon_subscription_empty4@2x.png"/>
                        <div class="following" v-else>+订阅</div>
                    </a>
                    <!-- 作者信息 -->
                    <a class="author-c-center" :href="personalPage" data-spm-data="3">
                        <img v-show="isShowAvatar" :src="authorAvatar"/>
                        <span>{{authorName}}</span>
                    </a>
                </div>
                <!-- 推广 -->
                <div class="center-header" v-show="isShowPromotion && !isForbiddenPromotion">
                    <div class="promotion-box">
                        <topRightSlide></topRightSlide>
                    </div>
                </div>
                <div class="navbar-icon" @click="clickNavIcon">
                    <span class="divide-line"></span>
                    <i class="icon-ic_unfold"></i>
                </div>
            </div>
            <!-- 频道导航 -->
            <div class="channel-nav" v-if="searchTopMenu.length">
                <div class="channel-c-scroll">
                    <div data-spm="nav-channel" class="channel-c">
                        <a v-for="(item,index) in searchTopMenu" :key="index" :href="item.url">
                            {{item.name}}
                        </a>
                    </div>
                </div>
                <img class="more-nav-icon" @click="loadNavLayer(true)" src="../less/images/more-nav.png"/>
            </div>
        </div>
        <!-- 按需加载全站导航 -->
        <div v-if="isLayerShow && !isLoading" >
            <nav-layer :config="navMap" @cancel="closeLayer" spm-a-b="smwp.content"/>
        </div>
        <div class="mask" v-if="showLoadingMask">加载中...</div>
    </div>
</template>
<script>
import Util from '../utils/util.js';
import LocalStorageUtil from '../utils/localstorageUtil.js'
import topRightSlide from './top-right-slide.vue';
import { getOdinResourceIdMap } from "@/config/odinResourceIds"
import { getOdinData } from '@/js/request/odinRequest'

export default {
    components: {
        topRightSlide,
    },
    data () {
        return {
            searchTopMenu: [], // 频道导航
            isLayerShow: false,
            isSohuRefer: true,
            navMap: {}, // 全站导航数据
            isShowFollowBtn: false, // 是否展示订阅按钮
            isShowAvatar: false, // 是否展示头像
            authorName: window.cfgs.authorName, // 作者昵称
            authorAvatar: window.cfgs.authorAvatar, // 作者头像
            personalPage: window.cfgs.personalPage, // 作者个人页
            authorId: window.cfgs.authorId, // 作者id
            followStatus: false, // 关注状态  true：已关注  false:未关注
            showAuthorFollow: false, //是否展示顶部作者信息以及订阅icon
            showAuthorFollowSeCount: 0, // 记录吸顶上报se次数
            isLoading: true, // 全站导航数据加载中
            isShowPromotion: true,
        }
    },
    created () {
        if(window?.cfgs?.searchTopMenu?.length) {
            
        }
        this.init()
    },
    computed: {
        showLoadingMask(){
            return this.isLayerShow && this.isLoading
        },
        isForbiddenPromotion(){
            return window.isForbiddenPromotion
        }
    },
    watch: {
        // 监听showAuthorFollow状态，只上报一次
        showAuthorFollow(_new,_old){
            if(this.showAuthorFollowSeCount> 1)return
            if(_new){
                this.$nextTick(()=>{
                    Util.domDidChange({target: 'nav'})
                    this.showAuthorFollowSeCount++
                })
            }
        }
    },
    mounted () {
        const isLocalstorageSearchUser = LocalStorageUtil.getItem('isLocalstorageSearchUser') || false // 本地记录为搜索来源
        const isFromSearch = Util.isFromSearch() // referer是否来自搜索来源
        const showChannelNav = (isLocalstorageSearchUser || isFromSearch) && window?.cfgs?.searchTopMenu?.length // 展示频道导航
        if(showChannelNav) {
            this.searchTopMenu = window?.cfgs?.searchTopMenu
            const articlePageDom = document.querySelector('.article-page')
            if(articlePageDom)articlePageDom.style.paddingTop = '80px'
            if(!isLocalstorageSearchUser)LocalStorageUtil.setItem('isLocalstorageSearchUser',true,this.getTimeDifferenceFromNext3AM()) // 搜索来源保持状态到凌晨3点
            this.$nextTick(()=>{
                window.sohuSpm?.domDidChange({target: 'nav-channel'})
            })
        }
        // 监听打开全站导航
        window.EVENT_BUS.$on('openNavLayer',this.openLayer)
        // 监听关注状态变化
        if(this.isShowFollowBtn){
            window.EVENT_BUS.$on('updateFollowStatus',this.updateFollowStatus)
        }
    },
    methods: {
        init () {
            const refer = document.referrer.split('?')[0]
            this.isSohuRefer = /.sohu.com/.test(refer)
            this.scrollInit()
            this.checkShowFollowBtnStatus()
        },
        // 获取定制化导航数据
        getCustomMenu() {
            return new Promise((resolve)=>{
                let urlConfig = {
                    prod: "//follow.mp.sohu.com/homepage/settings/loading?env=cloudProd",
                    pre: "http://test.follow.mp.sohu.com/homepage/settings/loading?env=cloudPre",
                    dev: "http://test.follow.mp.sohu.com/homepage/settings/loading?env=test",
                    test: "http://test.follow.mp.sohu.com/homepage/settings/loading?env=test"
                }
                const environment = window.MptcfeUtils.Utils.getEnvironment()
                $.ajax({
                    method: 'get',
                    url : urlConfig[environment],
                    type : 'json',
                    xhrFields: {withCredentials: true},
                    success: (data)=>{
                        if(data.data && data.data.customMenu) {
                            let customMenu = data.data.customMenu
                            this.navMap['customMenu'] = customMenu || []
                        }
                        resolve()
                    },
                    error: (e)=>{
                        resolve()
                    }
                })
            })
        },
        // 确认顶部的订阅与作者信息是否展示
        checkShowFollowBtnStatus() {
            if(document.querySelector('#followAuthor')){
                this.isShowFollowBtn = true
                if(document.querySelector('.avatar-container')){
                    this.isShowAvatar = true
                }
            }
        },
        scrollInit () {
            $(window).on('scroll', Util.throttle((e) => {
                let scrollTop = $(e.target).scrollTop()
                if(document.querySelector("#followAuthor")){
                    var followBtnBottom = document.querySelector(".cbd-follow-btn").getBoundingClientRect().bottom
                    this.isShowPromotion = scrollTop <= followBtnBottom
                    if(followBtnBottom <= 44 && !this.isShowPromotion){
                        this.showAuthorFollow = true
                    }else {this.showAuthorFollow = false}
                }else {
                    this.isShowPromotion = scrollTop <= 44
                }
            }, 200));
        },
        clickSohuBar () {
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: 8837
                });
            }
            window.history.back()
        },
        // 打开分享浮层,加载全站导航数据
        clickNavIcon () {
            window.h5_sohu.plugin.api.call("show_share", {showSecondLine: true, acode:10083}, function () {});
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: 10082
                });
            }
            // 预加载全站导航组件
            this.loadNavLayer()
        },
        loadNavLayer(open) {
            if(open)this.openLayer() // 立即打开全站导航
            Promise.all([
                import (/* webpackChunkName: "dynamic4navLayerjs" */ 'common-components/lib/navLayer/index.js'),
                import (/* webpackChunkName: "dynamic4navLayercss" */ 'common-components/lib/navLayer/index.css')
            ]).then(( [NavLayer] ) => {
                var NavLayerComp = NavLayer.default
                Vue.component("nav-layer", {
                    extends:NavLayerComp,
                    props: {
                        config: {
                            type: Object,
                            default: ""
                        }
                    }
                });
                // 若全站导航数据为空，则请求数据
                if(Object.keys(this.navMap)?.length === 0){
                    this.getCustomMenu().then(()=>{
                        this.navMapFetch()
                    })
                }
            })
        },
        openLayer() {
            this.isLayerShow = true
        },
        closeLayer(){
            this.isLayerShow = false
        },
        navMapFetch(){
                try {
                    const idsMap = getOdinResourceIdMap('allNavMap')
                    const spmObj = window?.sohuSpm?.getCodes()
                    const promiseList = []
                    idsMap.forEach((item)=>{
                        const params = {
                            tplCompKey: item?.tplCompKey,
                            adInfo: item.adInfo,
                            spmCCode: item.spmCCode,
                            resourceId: item.resourceId,
                            content: {
                                page: 1,
                                size: 30,
                                productId: item.productId,
                                productType: item.productType,
                                spm: `${spmObj?.a}.${spmObj?.b}.${item?.spmCCode}`
                            }
                        }
                        promiseList.push(getOdinData(params))
                    })
                    Promise.all(promiseList).then((res)=>{
                        res.forEach((item,index)=>{
                            this.navMap[idsMap?.[index]?.tplCompKey] = item?.list || []
                        })
                        this.isLoading = false
                    })
                } catch (error) {
                    this.isLoading = false
                    console.log(error,'全站导航')
                }
            },
        // 顶部导航订阅处理
        handleFollow() {
            var btn = document.querySelector('#followAuthor .cbd-follow-btn')
            if(btn)btn.click() //触发按钮事件
        },
        // 更新订阅状态
        updateFollowStatus(flag) {
            this.followStatus = flag || false
        },
        // 获取当前时间距离凌晨3点的时间差
        getTimeDifferenceFromNext3AM() {
            const now = new Date();// 获取当前时间
            let next3AM = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 3, 0, 0, 0);// 获取当天凌晨3点的时间
            if (now > next3AM) {// 如果当前时间已经超过今天的凌晨3点，则计算明天的凌晨3点
                next3AM.setDate(next3AM.getDate() + 1);
            }
            const timeDifference = next3AM - now;// 计算时间差（毫秒）
            return timeDifference;
        }
    }
}
</script>
<style lang="less" scoped>
.top-header-container{
    .top-header {
        position: relative;
        .header__l>.back-home {
            img {
                width: 112px;/*px*/
                height: 64px;/*px*/
            }
        }
        .center-header {
            .author-c-center {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                height: 88px;/*px*/
                display: flex;
                align-items: center;
                 img{
                        width: 44px;/*px*/
                        height: 44px;/*px*/
                        border: 2px solid #FFFFFF;/*px*/
                        border-radius: 50%;
                        margin-right: 8px;/*px*/
                        display: inline-block;
                    }
                    span{
                        font-weight: 500;/*px*/
                        color: #666666;
                        max-width: 162px;/*px*/
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display: inline-block;
                        font-size: 28px;/*px*/
                        line-height: 36px;/*px*/
                    }
            }
            #headerFollowAuthor {
                margin-left: auto;
            }
        }
        .promotion-box {
            height: 88px; /* px */
            flex: 1;
        }
    }
    .channel-nav {
        height: 72px;/*px*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 32px;/*px*/
        padding: 0 8px;/*px*/
        border-top: 2px solid #f2f2f2; /*px*/
        .channel-c-scroll {
            width: 0;
            height: 100%;
            flex: 1;
            overflow-x: auto;
            overflow-y: hidden;
            display: flex;
            &::-webkit-scrollbar {
                display: none;
            }
            scrollbar-width: none;
            .channel-c {
                flex: 1;
                display: flex;
                align-items: center;
                a {
                    display: flex;
                    padding: 0 24px;/*px*/
                    justify-content: center;
                    height: 100%;
                    align-items: center;
                    color: #666666;
                    flex-shrink: 0;
                }
            }
        }
        .more-nav-icon {
            width: 62px;/*px*/
            height: 72px;/*px*/
        }
    }
}
.bottom-shadow{
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06), 0px 8px 20px -4px rgba(0,0,0,0.07);
}
.mask {
    background-color: white;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;/*px*/
}
</style>


